module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zhHans":{"company":"一言为订"},"en":{"company":"YYWD"}}')
  delete Component.options._Ctor
}
